<div class="container-fluid" *ngIf="isLoaded" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">
      <div class="row">
        <div class="col-lg-6 mb-3 pr-1andahalf-lg">
          <div class="card">
            <div class="card-header">
              <fa-icon [icon]="['fas', 'marker']" size="lg" class="mr-2" [fixedWidth]="true"></fa-icon>{{ trad.tradTyp.namn }}
            </div>
            <div class="card-body">
              <p class="h5">{{ trad.arende.galdenar.orgnr }} {{ trad.arende.galdenar.namn }}</p>
              <ul class="list-unstyled">
                <li>
                  Avsändare
                  <ul class="list-unstyled ml-3">
                    <li><b>{{ trad.skapadAvNamn }}</b>, {{ trad.datumSkapad | localizeddate:'shortDate' }}</li>
                  </ul>
                </li>
                <li class="mt-2">
                  Ämne
                  <ul class="list-unstyled ml-3">
                    <li><b>{{ trad.amne }}</b></li>
                  </ul>
                </li>
                <li class="mt-2">
                  Status
                  <ul class="list-unstyled ml-3">
                    <li><b>{{ trad.status.namn }}</b></li>
                  </ul>
                </li>
              </ul>
              <button class="btn-garanti btn-blue mt-auto" (click)="scrollToTable('samlingsbeslut', 'enskilda-beslut')"><fa-icon [icon]="['fas', 'arrow-down']" class="mr-2"></fa-icon>Gå till signeringen</button>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-3 pl-1andahalf-lg">
          <div class="card">
            <div class="card-header">
              <fa-icon [icon]="['far', 'comments']" size="lg" class="mr-2" [fixedWidth]="true"></fa-icon>Konversation
            </div>
            <div class="card-body">
              <span class="d-flex justify-content-center text-muted" style="cursor: pointer" (click)="visaAllaMeddelanden = true" *ngIf="(trad.meddelanden.length > antalMeddelandenSomVisas) && !visaAllaMeddelanden">
                <fa-icon [icon]="['fas', 'caret-down']" size="lg" title="Visa tidigare meddelanden"></fa-icon>
              </span>
              <ng-container *ngFor="let meddelande of trad.meddelanden | orderBy: 'skapat'; let i = index">
                <div class="media pt-3" *ngIf="(i >= trad.meddelanden.length - antalMeddelandenSomVisas) || visaAllaMeddelanden">
                  <div class="avatar-circle mr-3 ml-lg-3 ml-0 z-depth-1" [style.background-color]="meddelande.avsandarTyp?.typ==='forv' ? '#d22' : '#22d'" [title]="meddelande.avsandareNamn">
                    <span class="initials">{{ meddelande.avsandareInitialer }}</span>
                  </div>
                  <p class="media-body pb-3 mb-0 small lh-125 border-bottom border-gray">
                    <span class="d-block"><strong class="text-gray-dark">{{ meddelande.avsandareNamn }}</strong>, {{ meddelande.avsandarTyp?.namn }}, {{ meddelande.skapat | localizeddate:'shortDate' }} {{ meddelande.skapat | localizeddate:'mediumTime' }}</span>
                    <span style="font-size: 1.2rem">{{ meddelande.meddelande }}</span>
                  </p>
                </div>
              </ng-container>
              <p class="text-muted" *ngIf="!trad.meddelanden.length">Inga meddelanden</p>
              <form [formGroup]="userForm" (ngSubmit)="createMessage()">
                <div class="form-group">
                  <textarea class="form-control mt-3" rows="3" placeholder="Skriv ett meddelande här..." id="message-text" name="message" formControlName="message"></textarea>
                  <label *ngIf="messageForm.dirty" class="label" [ngClass]="messageForm.invalid && message.length ? 'label-danger' : 'label-default'">{{ message.length | localizednumber }} / {{ messageMaxLength | localizednumber }} tecken</label>
                </div>
                <div class="container-fluid mt-3">
                  <div class="row">
                    <button type="submit" [disabled]="userForm.invalid" class="btn-garanti btn-blue ml-auto"><fa-icon [icon]="['fas', 'envelope']" class="mr-2"></fa-icon>{{ 'label.send-message' | translate }}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3" *ngIf="trad.b2Lista.length + trad.beslutLista.length">
        <div class="card-header">
          <fa-icon [icon]="['fas', 'gavel']" size="lg" class="mr-2" [fixedWidth]="true"></fa-icon>Beslut att signera ({{ signedB2Besluts.length + signedBesluts.length }} / {{ trad.b2Lista.length + trad.beslutLista.length }} signerade)
        </div>
        <div class="card-body">
          <div class="panel-group">
            <div *ngIf="trad.b2Lista.length" class="panel panel-default">
              <div class="panel-heading">
                <p class="h5">{{ trad.arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2:or (samlingsbeslut)</p>
              </div>
              <div class="panel-body">
                <div class="table-responsive">
                  <table class="table table-hover" id="samlingsbeslut">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 95px">
                          Typ
                        </th>
                        <th scope="col" [class.order-active]="b2BeslutOrderName==='datum'" (click)="setB2BeslutOrder('datum', ['datum'])">
                          <div class="d-flex justify-content-between">
                            Datum
                            <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="b2BeslutOrderName==='antalArbetstagare'" class="text-right-sm-left" (click)="setB2BeslutOrder('antalArbetstagare', ['antalArbetstagare'])">
                          <div class="d-flex justify-content-between">
                            <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="mr-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon>
                            Arbetstagare
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="b2BeslutOrderName==='period'" (click)="setB2BeslutOrder('period', ['periodFrom', 'periodTom'])">
                          <div class="d-flex justify-content-between">
                            Period
                            <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="b2BeslutOrderName==='lg'" class="text-right-sm-left" (click)="setB2BeslutOrder('lg', ['lgBeloppTotal'])">
                          <div class="d-flex justify-content-between">
                            <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="mr-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon>
                            Lönegaranti
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="b2BeslutOrderName==='netto'" class="text-right-sm-left" (click)="setB2BeslutOrder('netto', ['lgBeloppNetto'])">
                          <div class="d-flex justify-content-between">
                            <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="mr-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon>
                            Nettobelopp
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="b2BeslutOrderName==='dokument'" (click)="setB2BeslutOrder('dokument', ['harFil'])" style="width: 140px">
                          <div class="d-flex justify-content-between">
                            Dokument
                            <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon><
                          </div>
                        </th>
                        <th scope="col" class="text-center-sm-left" style="width: 160px">
                          Signatur
                        </th>
                        <th scope="col" class="text-center-sm-left" style="width: 45px">
                          Vald
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let b2 of getB2Beslut | orderBy:b2BeslutOrder:b2BeslutReverse:'case-insensitive'">
                        <tr>
                          <td data-name="Typ"><beslut-icon [arendeTyp]="trad.arende.arendeTyp" [beslutTyp]="{ typ: 'b2' }"></beslut-icon></td>
                          <td data-name="Datum">{{ b2.datum | localizeddate:'shortDate' }}</td>
                          <td data-name="Arbetstagare" class="text-right-sm-left">{{ b2.antalArbetstagare | localizednumber }} st</td>
                          <td data-name="Period">{{ b2.periodFrom | localizeddate:'shortDate' }} &ndash; {{ b2.periodTom | localizeddate:'shortDate' }}</td>
                          <td data-name="Lönegaranti" class="text-right-sm-left">{{ b2.lgBeloppTotal | localizednumber }} kr</td>
                          <td data-name="Nettobelopp" class="text-right-sm-left">{{ b2.lgBeloppNetto | localizednumber }} kr</td>
                          <td data-name="Dokument" *ngIf="b2.filer.length">
                            <file-link [file]="b2.fil"></file-link>
                            <div class="mt-3" *ngIf="b2.filer.length > 1">
                              <button type="button" (click)="showAttachments(b2)" class="btn btn-link" style="padding:0" [title]="b2.fil.beskrivning"><fa-icon [icon]="['fas', 'copy']" [fixedWidth]="true" size="lg" class="mr-2"></fa-icon>Bilagor ({{ b2.filer.length - 1 }})</button>
                            </div>
                          </td>
                          <td data-name="Dokument" *ngIf="!b2.filer.length">&ndash;</td>
                          <td data-name="Signatur" class="text-center-sm-left">
                            <signature-icon [signature]="b2.fil?.signatur"></signature-icon>
                          </td>
                          <td data-name="Vald" class="text-center-sm-left">
                            <div class="form-group mb-0">
                              <div class="checkbox">
                                <label class="mb-0">
                                  <input type="checkbox" class="form-check-input" [checked]="!!b2.isSelected || b2.arSignerad" [disabled]="b2.arSignerad" (change)="b2.isSelected = !b2.isSelected">
                                  <span class="cr"><fa-icon [icon]="['fas', 'check']" transform="grow-3" class="cr-icon"></fa-icon></span>
                                </label>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div *ngIf="trad.beslutLista.length" class="panel panel-default">
              <div class="panel-heading">
                <p class="h5">Enskilda beslut</p>
              </div>
              <div class="panel-body">
                <div class="table-responsive">
                  <table class="table table-hover" id="enskilda-beslut">
                    <thead>
                      <tr>
                        <th scope="col" [class.order-active]="beslutOrderName==='beslutTyp'" (click)="setBeslutOrder('beslutTyp', ['beslutTyp.typ'])" style="width: 95px">
                          <div class="d-flex justify-content-between">
                            Typ
                            <fa-icon [icon]="['fas', beslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="beslutReverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="beslutOrderName==='datum'" (click)="setBeslutOrder('datum', ['datum'])" style="width: 120px">
                          <div class="d-flex justify-content-between">
                            Datum
                            <fa-icon [icon]="['fas', beslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="beslutReverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="beslutOrderName==='namn'" (click)="setBeslutOrder('namn', ['anstallning.arbetstagare.fornamn', 'anstallning.arbetstagare.efternamn'])">
                          <div class="d-flex justify-content-between">
                            Namn
                            <fa-icon [icon]="['fas', beslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="beslutReverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="beslutOrderName==='period'" (click)="setBeslutOrder('period', ['periodFrom', 'periodTom'])">
                          <div class="d-flex justify-content-between">
                            Period
                            <fa-icon [icon]="['fas', beslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="beslutReverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="beslutOrderName==='lg'" class="text-right-sm-left" (click)="setBeslutOrder('lg', ['lgBeloppTotal_cache'])">
                          <div class="d-flex justify-content-between">
                            <fa-icon [icon]="['fas', beslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="mr-2" [flip]="beslutReverse||'vertical'"></fa-icon>
                            Lönegaranti
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="beslutOrderName==='fordran'" class="text-right-sm-left" (click)="setBeslutOrder('fordran', ['fordranBeloppTotal_cache'])">
                          <div class="d-flex justify-content-between">
                            <fa-icon [icon]="['fas', beslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="mr-2" [flip]="beslutReverse||'vertical'"></fa-icon>
                            Fordran
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="beslutOrderName==='dokument'" (click)="setBeslutOrder('dokument', ['harFil'])" style="width: 140px">
                          <div class="d-flex justify-content-between">
                            Dokument
                            <fa-icon [icon]="['fas', beslutReverse ? 'sort-amount-down' : 'sort-amount-up']" class="ml-2" [flip]="beslutReverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" class="text-center-sm-left" style="width: 160px">
                          Signatur
                        </th>
                        <th scope="col" class="text-center-sm-left" style="width: 45px">
                          Vald
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let beslut of getBeslut | orderBy:getBeslutOrder:beslutReverse:'case-insensitive'">
                        <td data-name="Typ"><beslut-icon [arendeTyp]="trad.arende.arendeTyp" [beslutTyp]="beslut.beslutTyp"></beslut-icon></td>
                        <td data-name="Datum">{{ beslut.datum | localizeddate:'shortDate' }}</td>
                        <td data-name="Namn">{{ beslut.anstallning.arbetstagare.fornamn }} {{ beslut.anstallning.arbetstagare.efternamn }}</td>
                        <td data-name="Period">{{ beslut.periodFrom | localizeddate:'shortDate' }} &ndash; {{ beslut.periodTom | localizeddate:'shortDate' }}</td>
                        <td data-name="Lönegaranti" class="text-right-sm-left">{{ beslut.lgBeloppTotal_cache | localizednumber }} kr</td>
                        <td data-name="Fordran" class="text-right-sm-left">{{ beslut.fordranBeloppTotal_cache | localizednumber }} kr</td>
                        <td data-name="Dokument" class="beslut-file"><file-link [file]="beslut.fil"></file-link></td>
                        <td data-name="Signatur" class="text-center-sm-left">
                          <signature-icon [signature]="beslut.fil?.signatur"></signature-icon>
                        </td>
                        <td data-name="Vald" class="text-center-sm-left">
                          <div class="form-group mb-0">
                            <div class="checkbox">
                              <label class="mb-0">
                                <input type="checkbox" class="form-check-input" [checked]="!!beslut.isSelected || beslut.arSignerad" [disabled]="beslut.arSignerad" (change)="beslut.isSelected = !beslut.isSelected">
                                <span class="cr"><fa-icon [icon]="['fas', 'check']" transform="grow-3" class="cr-icon"></fa-icon></span>
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid mb-3">
            <div class="row">
              <sign [files]="selectedFiles" [trad]="trad" (onSuccess)="reloadTrad()" class="d-flex w-100" btnClass="btn-garanti btn-blue ml-auto"></sign>
            </div>
          </div>
          <a [routerLink]="['/mina-tradar']" class="btn-garanti btn-blue"><fa-icon [icon]="['fas', 'arrow-left']" class="mr-2"></fa-icon>Tillbaka till mina meddelanden</a>
        </div>
      </div>
    </div>
  </div>
</div>
